import React from "react";
import { useAppSelector } from "store";

import { Grid, GridSize } from "@material-ui/core";

import { selectIsInsightExpanded } from "modules/customer/tools/location/locationSlice";

import CatchmentAreaSpendByMarketAndProductCategory from "./CatchmentAreaSpendByMarketAndProductCategory";
import CatchmentAreaSpendPerHead from "./CatchmentAreaSpendPerHead";
import CatchmentAreaYearlySpend from "./CatchmentAreaYearlySpend";

const TotalSpend: React.FC = () => {
    const isInsightExpanded = useAppSelector(selectIsInsightExpanded);
    const kpiGridSize: GridSize = isInsightExpanded ? 6 : 12;

    return (
        <Grid container spacing={2}>
            <Grid item xs={kpiGridSize}>
                <CatchmentAreaYearlySpend />
            </Grid>
            <Grid item xs={kpiGridSize}>
                <CatchmentAreaSpendPerHead />
            </Grid>
            <Grid item xs={12}>
                <CatchmentAreaSpendByMarketAndProductCategory />
            </Grid>
        </Grid>
    );
};

export default TotalSpend;
